// export const API_URL = 'http://localhost:3200/api';
// production
// export const API_URL = 'https://api.v2.transalliance.ql6625.fr/api';
// staging
// export const API_URL = process.env.REACT_APP_API_URL || 'https://api.v3.transalliance.ql6625.fr/api';
// export const API_URL = process.env.REACT_APP_API_URL || 'https://api.v3.staging.transalliancehub.ql6625.fr/api';
// export const API_URL = process.env.REACT_APP_API_URL || 'https://api.transalliancehub.staging.bfast-vn.net/api';
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.driver.pprod.cloud.transalliance.eu/api';
export const TABLEAU_DE_BORD_URL = process.env.REACT_APP_TABLEAU_DE_BORD_URL || 'https://dashboard.transalliance.ql6625.live';
